import { render, staticRenderFns } from "./HardSoftConsonantsForm.vue?vue&type=template&id=0db98e94&scoped=true&lang=pug&"
import script from "./HardSoftConsonantsForm.vue?vue&type=script&lang=js&"
export * from "./HardSoftConsonantsForm.vue?vue&type=script&lang=js&"
import style0 from "./HardSoftConsonantsForm.vue?vue&type=style&index=0&id=0db98e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db98e94",
  null
  
)

export default component.exports